var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toc"},_vm._l((_vm.chapters),function(chapter){return _c('div',{staticClass:"chapter"},[_c('div',{staticClass:"section-link",on:{"click":function($event){_vm.gotoSection(chapter.vtitle)}}},[_vm._v(_vm._s(chapter.vtitle))])])}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6946f428","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TOC.vue
// module id = 2803
// module chunks = 1